import React, { createContext, useContext } from 'react';
import type { ModalState } from './useModal';

/*
 * To be used with in combination with the useModal()
 * When wrapped with other components this allows for the modal state to be shared without having to prop drill
 */
export const ShareModalContext = createContext<ModalState<any, any> | null>(null);
interface ShareModalProviderProps<T, K> {
  state: ModalState<T, K>;
  children: React.ReactNode;
}

export function ShareModalProvider<T, K>({ state, children }: ShareModalProviderProps<T, K>) {
  return <ShareModalContext.Provider value={state}>{children}</ShareModalContext.Provider>;
}

export function useShareModalContext<T, K>() {
  const context = useContext(ShareModalContext);

  if (!context) {
    throw new Error('useMenuContext must be used within a MenuProvider');
  }

  return context as ModalState<T, K>;
}
